<div [ngClass]="{ 'popup-drawer-half-size' : (width === 'half'),
'popup-drawer-full-size': (width !== 'half'), 'overlay' : showOverlay}" *ngIf="openDrawer" (click)="showHideDrawer()">
</div>
<div class="popup-drawer black-background myclass" [id]="drawerId" [ngClass]="{ 'open' : openDrawer , 'mob-no-scroll': !drawerScroll,
 'popup-drawer-half-size' : (width === 'half') , 'popup-drawer-full-size': (width !== 'half')}" #drawer>
    <div *ngIf="!hideMinimizeBtn" class="center">
        <div class="line" (click)="drawerMinimized = !drawerMinimized"></div>
    </div>
    <ng-content *ngIf="!drawerMinimized"></ng-content>
</div>